export const FORM_INPUT = () => {
  return [
    {
      name: 'search',
      type: 'INPUT',
      placeholder: 'กรอกรหัสรับประกัน',
    },
  ];
};
